
import { Watch, Component, Vue, Ref } from "vue-property-decorator";
import PrescriptionLib from "./component/prescriptionLib.vue";
import ModuleNameConfig from "./component/moduleNameConfig.vue";

@Component({ name: 'prescription-db-merchant',
  components: {
    PrescriptionLib,
    ModuleNameConfig,
  },
})
export default class PrescriptionDb extends Vue {
  @Ref("prescriptionLib") readonly prescriptionLibRef!: PrescriptionLib;

  merchantId = this.$route.query.merchantId;
  brandName = this.$route.query.brandName;

  outerTab = "1";

  // 配置页保存后切回处方库时，刷新模块名称
  @Watch("outerTab")
  onOuterTabChange(value: string) {
    if (value === "1") {
      this.prescriptionLibRef?.refreshModuleTitles();
    }
  }
}
